
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gu4Ydd8VV_CdMUcwk_452oC8TmdtIdqVXcbOutn98u5tj4Meta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index61nIZFp_BlXRAaGtaWQWqppzMjPVUvwLbMNVQEMqpsUMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchoRZAROeuIAzaAgkhx9F8ooHRpc77EKo03MYkNzPgF7wMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexSmhHzUAzTlldUzVdmDdASakAgbFQee8kOPxfo3ZRDNEMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93M10d8wZh71WWq_5ttl6QffMTxeENg2O7yYOiT4NHZdQMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexVae_4532TSt1NYuQQwtUrscf3DiipwRx40FSOmrtRj_459kMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93qprEP_45tqVDxY03wGBOIeAirJE4Ip_45xcC54YsueHEEeoMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexZPOZnAc70QOlMygXqQznx0BjAONiE4aJ2O0L8XJnocIMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93HiZsabqt8q5_hcEXbO_450DP51x0A42How9ZHn8SXn2EgMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index2W7I9Hlr9B4Obgv0FOr5_45XeH6NM4e8AtKthKj5BwjgoMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexUqrBeA_Kd60ZtpVxe3PbRU5PctUSA_45_45Kok3Y12pST0MMeta } from "/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexVae_4532TSt1NYuQQwtUrscf3DiipwRx40FSOmrtRj_459kMeta || {},
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexZPOZnAc70QOlMygXqQznx0BjAONiE4aJ2O0L8XJnocIMeta || {},
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index2W7I9Hlr9B4Obgv0FOr5_45XeH6NM4e8AtKthKj5BwjgoMeta || {},
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexUqrBeA_Kd60ZtpVxe3PbRU5PctUSA_45_45Kok3Y12pST0MMeta || {},
    component: () => import("/codebuild/output/src3783163090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]